import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { LoadingSkeleton } from '../_shared/LoadingSkeleton/LoadingSkeleton';
import styles from './ArtistSkeleton.module.scss';
import { getArtistTranslatedTexts } from './utils';

const ArtistSkeleton: React.FC<{
    artistType: string;
    artistList: Array<{ artistId: string; tagline: string }>;
}> = ({ artistType, artistList }) => {
    const artistTranslatedTexts = getArtistTranslatedTexts();
    return (
        <div className={styles.container}>
            <Typography
                as="h2"
                variant="heading-sm"
                className={styles.title}
                color="neutral-900"
            >
                {artistType}
            </Typography>
            <div className={styles.artistList}>
                {artistList.slice(0, 6).map((artist) => (
                    <LoadingSkeleton
                        key={artist.artistId}
                        height="96px"
                        customClassName={styles.artistSkeleton}
                    />
                ))}
            </div>
            {artistList.length > 6 && (
                <Button
                    variant="secondary"
                    size="block"
                    sizeVariant="large"
                    className={styles.button}
                >
                    {artistTranslatedTexts.VIEW_ALL}
                </Button>
            )}
        </div>
    );
};

export default ArtistSkeleton;
